// Break out the application running from the configuration definition to
// assist with testing.
define('main', [],function () {
  require(['config', 'services/auth/index'], function (config, AuthService) {
    // Kick off the application.
    require(['app', 'env'], function (app, env) {
      app.i18nInit(function () {
        var authService = AuthService(env);
        authService.login(function (isLogged) {
          if (isLogged) {
            authService.getCompanyInfo(app.setCompanyInfo);
            app.start();
          }
        });
      });
    });
  });
});

